import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-2" }

import {ref} from 'vue';
import ChatModalMessage from "~/chat/vue/widget/ChatModalMessage.vue";
import {__} from "~/ts/library/Translate";
import {WidgetStore} from "~/chat/ts/store/Widget";
import ChatRecaptcha from "~/chat/vue/widget/form/fields/ChatRecaptcha.vue";
import Random from "~/ts/library/Random";
import {ConfigStore} from "~/chat/ts/store/Config";
import {CLIENT_CAPTCHA_FIELD_NAME} from "~/chat/ts/data/IClient";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import {CLIENT_CAPTCHA_SOLVED} from "~/chat/ts/Constants";


const __default__ = {
    name: "ClientCaptcha"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let visible = WidgetStore.showClientCaptcha;

let instanceId = ref<string>(null);

function reload() {
    instanceId.value = Random.uid();
}

async function onInput(data: any) {
    let result = await ChatApiRequest.make({
        method: "solveClientCaptcha",
        p: {
            captcha: data
        }
    });
    if (result.isSuccess()) {
        ChatEventManagerInstance.emit(CLIENT_CAPTCHA_SOLVED);
    }
}


return (_ctx: any,_cache: any) => {
  return (_unref(visible))
    ? (_openBlock(), _createBlock(ChatModalMessage, {
        key: 0,
        "show-close-in-footer": false,
        "show-close-in-title": false,
        visible: _unref(visible),
        title: _unref(__)('NEED_CAPTCHA')
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(ChatRecaptcha, {
            key: _unref(instanceId),
            field: _unref(ConfigStore).siteParams.value.formElements[_unref(CLIENT_CAPTCHA_FIELD_NAME)],
            "onUpdate:modelValue": onInput
          }, null, 8, ["field"])),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(ChatFormButton, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (reload())),
              class: "d-block w-100"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("REFRESH")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"]))
    : _createCommentVNode("", true)
}
}

})